import { SdohSingleAnswerAdvanced } from './SdohSingleAnswerAdvanced.model';

export default interface IPersonalCharacteristics {
    LanguageAreMostComfortableSpeaking: SdohSingleAnswerAdvanced | null;
    DoYouHaveProblemsReading: SdohSingleAnswerAdvanced | null;
    DoYouHaveProblemsWriting: SdohSingleAnswerAdvanced | null;
    HaveProblemsInReadingHealthLiterature: SdohSingleAnswerAdvanced | null;
    SexualOrientation: SdohSingleAnswerAdvanced | null;
    PreferredPronouns: SdohSingleAnswerAdvanced | null;
    PreferredPronounsOther: SdohSingleAnswerAdvanced | null;
    Race: SdohSingleAnswerAdvanced | null;
    CommunicationBarriers: SdohSingleAnswerAdvanced | null;
    IsAILanguageAreMostComfortableSpeaking?: boolean;
    IsAIDoYouHaveProblemsReading?: boolean;
    IsAIDoYouHaveProblemsWriting?: boolean;
    IsAIHaveProblemsInReadingHealthLiterature?: boolean;
    IsAISexualOrientation?: boolean;
    IsAICommunicationBarriers?: boolean;
}

export class PersonalCharacteristics implements IPersonalCharacteristics {
    LanguageAreMostComfortableSpeaking: SdohSingleAnswerAdvanced | null;
    DoYouHaveProblemsReading: SdohSingleAnswerAdvanced | null;
    DoYouHaveProblemsWriting: SdohSingleAnswerAdvanced | null;
    HaveProblemsInReadingHealthLiterature: SdohSingleAnswerAdvanced | null;
    SexualOrientation: SdohSingleAnswerAdvanced | null;
    PreferredPronouns: SdohSingleAnswerAdvanced | null;
    PreferredPronounsOther: SdohSingleAnswerAdvanced | null;
    Race: SdohSingleAnswerAdvanced | null;
    CommunicationBarriers: SdohSingleAnswerAdvanced | null;
    IsAILanguageAreMostComfortableSpeaking?: boolean;
    IsAIDoYouHaveProblemsReading?: boolean;
    IsAIDoYouHaveProblemsWriting?: boolean;
    IsAIHaveProblemsInReadingHealthLiterature?: boolean;
    IsAISexualOrientation?: boolean;
    IsAICommunicationBarriers?: boolean;

    constructor() {
        this.LanguageAreMostComfortableSpeaking = new SdohSingleAnswerAdvanced();
        this.DoYouHaveProblemsReading = new SdohSingleAnswerAdvanced();
        this.DoYouHaveProblemsWriting = new SdohSingleAnswerAdvanced();
        this.HaveProblemsInReadingHealthLiterature = new SdohSingleAnswerAdvanced();
        this.SexualOrientation = new SdohSingleAnswerAdvanced();
        this.PreferredPronouns = new SdohSingleAnswerAdvanced();
        this.PreferredPronounsOther = new SdohSingleAnswerAdvanced();
        this.Race = new SdohSingleAnswerAdvanced();
        this.CommunicationBarriers = new SdohSingleAnswerAdvanced();
    }
}
